import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button, LoadingBarIndicator } from '@components';
import { Box } from '@mui/material';
import { CaminhosPDFService } from '@services';

export const CusteioAdminsitrativoPage = () => {
  const { matricula, token } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [responseDemonstrativo, setResponseDemonstrativo] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const caminhosPDFService = new CaminhosPDFService();
    caminhosPDFService
      .gerarDemonstrativoCusteioAdmin(matricula, token)
      .then((res) => {
        setResponseDemonstrativo(
          new Blob([res.data], { type: 'application/pdf' })
        );
        setLoading(false);
      });
  }, [matricula, token]);

  return (
    <>
      <Helmet>
        <title>Forluz - Demonstrativo de Custeio Administrativo</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Demonstrativo de Custeio Administrativo</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center">
            {loading ? (
              <>
                <h3 className="fw-bold mb-0">Carregando o arquivo:</h3>
                <Box sx={{ flex: 1, ml: 2 }}>
                  <LoadingBarIndicator />
                </Box>
              </>
            ) : (
              <>
                <h3 className="fw-bold mb-0">
                  Demonstrativo de custeio administrativo:
                </h3>
                {!responseDemonstrativo.error ? (
                  <Box sx={{ ml: 2 }}>
                    <a
                      href={window.URL.createObjectURL(responseDemonstrativo)}
                      rel="noreferrer"
                      target="_blank"
                      download={`Demonstrativo de custeio administrativo - ${matricula}.PDF`}
                      title="Clique para baixar o demonstrativo"
                      className="d-md-flex ts-14 aButtonTransparent"
                    >
                      Baixar arquivo
                    </a>
                  </Box>
                ) : (
                  <h3 className="fw-bold mb-0 text-error ms-xxl-2">
                    {responseDemonstrativo.error}
                  </h3>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
